
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33997',
  depVersions: {
  "documents-public-ui": "static-1.33997",
  "client-types": "static-1.446",
  "documents-lib": "static-1.34002",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1937",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4841",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5403",
  "hs-test-utils": "static-1.7815",
  "hub-http": "static-1.6030",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11242",
  "I18n": "static-7.1572",
  "jasmine-immutable": "static-1.2828",
  "jasmine-runner": "static-1.6282",
  "lodash": "static-1.3",
  "quartz": "static-1.6748",
  "react": "static-7.179",
  "react-dlb": "static-1.72",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16460",
  "reporting-data": "static-1.66567",
  "reporting-testing-lib": "static-1.8500",
  "reporting-visualizations": "static-1.58643",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4575",
  "webpack-env": "static-1.54",
  "atom": "static-1.4879",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2296",
  "classnames": "static-2.10",
  "cssUtils": "static-1.734",
  "customer-data-filters-ui": "static-1.38941",
  "customer-data-objects": "static-1.7459",
  "customer-data-property-utils": "static-1.7887",
  "data-fetching-client": "static-1.9487",
  "enviro": "static-4.405",
  "FireAlarmUi": "static-1.4338",
  "flux-actions": "static-1.310",
  "FormsCommonComponents": "static-1.85310",
  "FormUrlGenerator": "static-2.4539",
  "foundations-components": "static-1.7542",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11550",
  "icons": "static-2.623",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6970",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.367",
  "property-description-translator": "static-1.3668",
  "property-translator": "static-1.5222",
  "quartz-config": "static-1.526",
  "quartz-core": "static-1.5967",
  "quick-fetch": "static-1.3744",
  "raven": "static-3.5725",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5182",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7970",
  "reference-resolvers-lite": "static-1.7904",
  "report-customization-components": "static-1.12531",
  "reporting-enablement": "static-1.22107",
  "reporting-reports": "static-1.66245",
  "reporting-snowflake": "static-1.55185",
  "reporting-ui-components": "static-2.63838",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4444",
  "sales-content-partitioning": "static-1.8745",
  "SalesContentIndexUI": "static-3.8917",
  "sanitize": "static-1.4284",
  "sanitize-text": "static-1.7950",
  "self-service-api": "static-1.10046",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1562",
  "signup-constants": "static-1.18425",
  "signup-ui-lego-core": "static-1.20435",
  "signup-ui-url-generator": "static-2.7858",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4580",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10804",
  "ui-addon-i18n": "static-1.10950",
  "ui-addon-react-router-dom": "static-1.9356",
  "ui-addon-upgrades": "static-9.17675",
  "ui-asset-management-lib": "static-1.10723",
  "ui-images": "static-2.1094",
  "UIComponents": "static-3.8189",
  "usage-tracker": "static-1.7144",
  "usage-tracker-container": "static-1.7134",
  "usage-tracker-core": "static-1.6994",
  "usage-tracker-public": "static-1.6955",
  "viral-links-lib": "static-1.6845",
  "hs-promise-rejection-tracking": "static-1.5387",
  "raven-hubspot": "static-1.6032",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3238",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3025",
  "quartz-webpack": "static-1.2972",
  "ai-components-ui-library": "static-1.8369",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4646",
  "foundations-theming": "static-1.4221",
  "quartz-auth": "static-1.423",
  "ui-business-units-lib": "static-1.8838",
  "usage-tracker-session-replay": "static-1.4830",
  "foundations-theming-base": "static-1.3206",
  "HeadJS": "static-2.711",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2926",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4136",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7734",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3426",
  "persist-promise": "static-1.3518",
  "reporting-client-types": "static-1.2387",
  "foundations-components-legacy": "static-1.567",
  "hs-story-utils": "static-1.9237",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9497",
  "hubspotter-http": "static-1.4487",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7057",
  "crm-message-bus": "static-1.42395",
  "customer-data-filters-ui-msw-helpers": "static-1.21376",
  "customer-data-objects-ui-components": "static-1.12817",
  "customer-data-reference-ui-components": "static-1.12955",
  "customer-data-ui-utilities": "static-1.9633",
  "framework-builder-read-service-client": "static-1.3842",
  "framework-data-schema-quick-fetch": "static-1.6588",
  "framework-data-schema-resolvers": "static-1.6683",
  "inbound-db-properties-service-client": "static-1.3684",
  "multi-account-reference-resolvers": "static-1.783",
  "onboarding-tours": "static-1.16275",
  "reporting-datasets-permissions-lib": "static-1.13081",
  "ui-addon-teams": "static-1.21257",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67651",
  "customer-data-properties": "static-1.50826",
  "forms-ai-lib": "static-1.4021",
  "forms-utils-lib": "static-1.12185",
  "foundations-components-test-utils": "static-1.5025",
  "react-dnd-compat": "static-1.4430",
  "react-tinymce": "static-1.54647",
  "tinymce-config": "static-2.53773",
  "ui-gdpr-components": "static-1.10157",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3811",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1234",
  "ui-fonts": "static-1.504",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.796",
  "mobile-manifest-mixins": "static-1.484",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.413",
  "quartz-i18n": "static-1.423",
  "quartz-routing": "static-1.178",
  "quartz-test": "static-1.423",
  "quartz-tracking": "static-1.127",
  "batch-promise": "static-1.1361",
  "external-options-client-types": "static-1.3993",
  "react-colorpicker": "static-2.10019",
  "copilot-toolkit": "static-1.10557",
  "data-quality-ui-library": "static-1.12342",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40681",
  "reporting-insights-lib": "static-1.1191",
  "reporting-plugins": "static-1.9996",
  "ui-addon-draggable-compat": "static-2.4063",
  "ui-addon-opt": "static-4.8194",
  "ui-shepherd-react": "static-3.9957",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24755",
  "hubspot-apollo-client": "static-1.4691",
  "sales-templates-service-types-lib": "static-1.4000",
  "merchandise-lib": "static-1.259",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5495",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3913",
  "timezone-utils": "static-2.5054",
  "bender-build-tools": "static-1.2956",
  "chatspot-core": "static-1.20361",
  "chirp-fetch": "static-1.1692",
  "bend-plugin-foundations-theming": "static-1.2704",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9495",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3632",
  "crm-pipelines-api-client-types": "static-1.3973",
  "multi-currency-client-types": "static-1.3526",
  "getting-started-shared-tasks": "static-1.17913",
  "growth-data-modal": "static-1.5168",
  "growth-onboarding-confetti": "static-1.2882",
  "growth-onboarding-next-action-utils": "static-1.1315",
  "navigation-components": "static-1.17299",
  "onboarding-tours-client": "static-1.4489",
  "onboarding-tours-utils": "static-1.341",
  "ui-shepherd-tracker": "static-1.7338",
  "ui-universal-auth": "static-1.8713",
  "user-context": "static-1.4909",
  "cms-field-types": "static-1.4616",
  "content-icons-ui": "static-1.2156",
  "integrations-lib": "static-1.15447",
  "calling-global-api": "static-1.63706",
  "calling-internal-common": "static-1.31104",
  "calling-lifecycle-internal": "static-1.65088",
  "calling-lifecycle-messages": "static-1.57382",
  "commerce-products-lib": "static-1.8887",
  "crm-links": "static-1.6076",
  "file-manager-components": "static-1.22917",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.488",
  "inbounddb-objects-service-types": "static-1.4057",
  "meetings-icalendar-utils-lib": "static-1.443",
  "object-builder-ui-client": "static-1.48011",
  "pipeline-validation-client-types": "static-1.3795",
  "property-value-citations": "static-1.1440",
  "pulse": "static-1.322",
  "smart-property-lib": "static-1.5950",
  "tiered-pricing": "static-1.844",
  "ui-addon-iframeable": "static-1.8854",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19485",
  "tinymce-themes": "static-1.55743",
  "data-token-picker": "static-1.16057",
  "hub-http-contrib": "static-1.2853",
  "interframe": "static-3.4599",
  "tinymce-data": "static-1.39858",
  "tinymce-plugins": "static-1.56887",
  "ui-addon-sales-email": "static-1.5023",
  "magpie-lib": "static-1.5403",
  "magpie-types": "static-1.4863",
  "simple-logging-lib": "static-1.2860",
  "content-assistance-lib": "static-1.7463",
  "dashboard-lib": "static-1.80666",
  "ExportDialog": "static-6.10196",
  "hubspot-prosemirror": "static-1.17633",
  "hubspot-prosemirror-plugins": "static-1.17625",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8501",
  "campaign-roi-lib": "static-1.8303",
  "feedback-loader": "static-1.28872",
  "onboarding-scopes": "static-1.6273",
  "apollo-link-hub-http": "static-2.4459",
  "hubspot-apollo-cache": "static-1.150",
  "growth-monetization-service-types": "static-1.4323",
  "nav-client-types": "static-1.2167",
  "purchase-motions-api": "static-1.5498",
  "trials-service-types": "static-1.3724",
  "growth-onboarding-next-action-components": "static-1.1343",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.535",
  "unified-auth-core-lib": "static-1.508",
  "getting-started-shared-tasks-store": "static-1.17031",
  "integrations-error-boundary-lib": "static-1.12862",
  "integrations-tracking-lib": "static-1.5398",
  "native-integrations-shared-strings": "static-1.7598",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10181",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31110",
  "shared-worker-versioning": "static-1.10848",
  "calling-usage-tracker": "static-1.6350",
  "voice-sms-access-library": "static-1.275",
  "customer-data-tracking": "static-1.6692",
  "commerce-permissions": "static-1.568",
  "products-iframe-lib": "static-1.7344",
  "products-ui-components-shared-msw-handlers": "static-1.9879",
  "location-customization-utils-lib": "static-1.8592",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3965",
  "video-components-external": "static-1.10595",
  "video-data-lib": "static-1.34254",
  "directed-graph": "static-1.746",
  "event-emitter": "static-1.757",
  "breeze-intelligence-kit": "static-1.5334",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9580",
  "fsm": "static-1.3541",
  "policy-lib": "static-1.6596",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9643",
  "navigation-messaging": "static-1.6626",
  "FileManagerLib": "static-1.38557",
  "NamespacedHubStyle": "static-2.8905",
  "FileManagerCore": "static-1.38416",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12050",
  "layout-dnd-utils": "static-1.11025",
  "react-codemirror": "static-1.10436",
  "ui-addon-emoji-picker": "static-1.9698",
  "ui-brand-identity-lib": "static-1.13926",
  "ui-addon-video-player": "static-1.8506",
  "ui-coaching-tips": "static-1.27969",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8378",
  "payment-link-components": "static-1.22967",
  "EmailSignatureEditor": "static-1.23929",
  "eligibility-engine-service-types": "static-1.3005",
  "universal-page-editor-lib": "static-1.2809",
  "calling-orchestration-schema": "static-1.35052",
  "sales-views-client-types": "static-1.4097",
  "crm-record-cards-service-types": "static-1.3460",
  "content-media-composition-data-lib": "static-1.11490",
  "content-media-compositions": "static-2.15497",
  "media-bridge-lib": "static-1.18580",
  "trellis-story-utils": "static-1.4331",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5626",
  "FileManagerImages": "static-1.36068",
  "video-components": "static-1.12598",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4342",
  "video-embed": "static-1.35088",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67726",
  "layout-data-lib": "static-1.9350",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6393",
  "commerce-tours-lib": "static-1.5734",
  "growth-onboarding-reliability": "static-1.4896",
  "sales-checkout-service-client": "static-1.3478",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21322",
  "sales-email-signature-service-client": "static-1.3654",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21377",
  "outpost": "static-1.4014",
  "advanced-menus-core": "static-1.14828",
  "advanced-menus-lib": "static-1.11801",
  "ui-memberships-settings-lib": "static-1.33451",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14827",
  "simple-menus-lib": "static-1.16344"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33997",
  "client-types": "/client-types/static-1.446",
  "documents-lib": "/documents-lib/static-1.34002",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1937",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4841",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5403",
  "hs-test-utils": "/hs-test-utils/static-1.7815",
  "hub-http": "/hub-http/static-1.6030",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11242",
  "I18n": "/I18n/static-7.1572",
  "jasmine-immutable": "/jasmine-immutable/static-1.2828",
  "jasmine-runner": "/jasmine-runner/static-1.6282",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6748",
  "react": "/react/static-7.179",
  "react-dlb": "/react-dlb/static-1.72",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16460",
  "reporting-data": "/reporting-data/static-1.66567",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8500",
  "reporting-visualizations": "/reporting-visualizations/static-1.58643",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4575",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4879",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2296",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.734",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38941",
  "customer-data-objects": "/customer-data-objects/static-1.7459",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7887",
  "data-fetching-client": "/data-fetching-client/static-1.9487",
  "enviro": "/enviro/static-4.405",
  "FireAlarmUi": "/FireAlarmUi/static-1.4338",
  "flux-actions": "/flux-actions/static-1.310",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85310",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4539",
  "foundations-components": "/foundations-components/static-1.7542",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11550",
  "icons": "/icons/static-2.623",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6970",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "property-description-translator": "/property-description-translator/static-1.3668",
  "property-translator": "/property-translator/static-1.5222",
  "quartz-config": "/quartz-config/static-1.526",
  "quartz-core": "/quartz-core/static-1.5967",
  "quick-fetch": "/quick-fetch/static-1.3744",
  "raven": "/raven/static-3.5725",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5182",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7970",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7904",
  "report-customization-components": "/report-customization-components/static-1.12531",
  "reporting-enablement": "/reporting-enablement/static-1.22107",
  "reporting-reports": "/reporting-reports/static-1.66245",
  "reporting-snowflake": "/reporting-snowflake/static-1.55185",
  "reporting-ui-components": "/reporting-ui-components/static-2.63838",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4444",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8745",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8917",
  "sanitize": "/sanitize/static-1.4284",
  "sanitize-text": "/sanitize-text/static-1.7950",
  "self-service-api": "/self-service-api/static-1.10046",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1562",
  "signup-constants": "/signup-constants/static-1.18425",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20435",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4580",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10804",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10950",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9356",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17675",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10723",
  "ui-images": "/ui-images/static-2.1094",
  "UIComponents": "/UIComponents/static-3.8189",
  "usage-tracker": "/usage-tracker/static-1.7144",
  "usage-tracker-container": "/usage-tracker-container/static-1.7134",
  "usage-tracker-core": "/usage-tracker-core/static-1.6994",
  "usage-tracker-public": "/usage-tracker-public/static-1.6955",
  "viral-links-lib": "/viral-links-lib/static-1.6845",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3238",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3025",
  "quartz-webpack": "/quartz-webpack/static-1.2972",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8369",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4646",
  "foundations-theming": "/foundations-theming/static-1.4221",
  "quartz-auth": "/quartz-auth/static-1.423",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8838",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4830",
  "foundations-theming-base": "/foundations-theming-base/static-1.3206",
  "HeadJS": "/HeadJS/static-2.711",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2926",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4136",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7734",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3426",
  "persist-promise": "/persist-promise/static-1.3518",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.567",
  "hs-story-utils": "/hs-story-utils/static-1.9237",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9497",
  "hubspotter-http": "/hubspotter-http/static-1.4487",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7057",
  "crm-message-bus": "/crm-message-bus/static-1.42395",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21376",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12817",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12955",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9633",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3842",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6588",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6683",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3684",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.783",
  "onboarding-tours": "/onboarding-tours/static-1.16275",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13081",
  "ui-addon-teams": "/ui-addon-teams/static-1.21257",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67651",
  "customer-data-properties": "/customer-data-properties/static-1.50826",
  "forms-ai-lib": "/forms-ai-lib/static-1.4021",
  "forms-utils-lib": "/forms-utils-lib/static-1.12185",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5025",
  "react-dnd-compat": "/react-dnd-compat/static-1.4430",
  "react-tinymce": "/react-tinymce/static-1.54647",
  "tinymce-config": "/tinymce-config/static-2.53773",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10157",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3811",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1234",
  "ui-fonts": "/ui-fonts/static-1.504",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.796",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.484",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.413",
  "quartz-i18n": "/quartz-i18n/static-1.423",
  "quartz-routing": "/quartz-routing/static-1.178",
  "quartz-test": "/quartz-test/static-1.423",
  "quartz-tracking": "/quartz-tracking/static-1.127",
  "batch-promise": "/batch-promise/static-1.1361",
  "external-options-client-types": "/external-options-client-types/static-1.3993",
  "react-colorpicker": "/react-colorpicker/static-2.10019",
  "copilot-toolkit": "/copilot-toolkit/static-1.10557",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12342",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40681",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1191",
  "reporting-plugins": "/reporting-plugins/static-1.9996",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4063",
  "ui-addon-opt": "/ui-addon-opt/static-4.8194",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9957",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24755",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4691",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4000",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5495",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3913",
  "timezone-utils": "/timezone-utils/static-2.5054",
  "bender-build-tools": "/bender-build-tools/static-1.2956",
  "chatspot-core": "/chatspot-core/static-1.20361",
  "chirp-fetch": "/chirp-fetch/static-1.1692",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2704",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9495",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3632",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3973",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3526",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17913",
  "growth-data-modal": "/growth-data-modal/static-1.5168",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2882",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1315",
  "navigation-components": "/navigation-components/static-1.17299",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4489",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.341",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7338",
  "ui-universal-auth": "/ui-universal-auth/static-1.8713",
  "user-context": "/user-context/static-1.4909",
  "cms-field-types": "/cms-field-types/static-1.4616",
  "content-icons-ui": "/content-icons-ui/static-1.2156",
  "integrations-lib": "/integrations-lib/static-1.15447",
  "calling-global-api": "/calling-global-api/static-1.63706",
  "calling-internal-common": "/calling-internal-common/static-1.31104",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65088",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57382",
  "commerce-products-lib": "/commerce-products-lib/static-1.8887",
  "crm-links": "/crm-links/static-1.6076",
  "file-manager-components": "/file-manager-components/static-1.22917",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.488",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4057",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.443",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48011",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3795",
  "property-value-citations": "/property-value-citations/static-1.1440",
  "pulse": "/pulse/static-1.322",
  "smart-property-lib": "/smart-property-lib/static-1.5950",
  "tiered-pricing": "/tiered-pricing/static-1.844",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8854",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19485",
  "tinymce-themes": "/tinymce-themes/static-1.55743",
  "data-token-picker": "/data-token-picker/static-1.16057",
  "hub-http-contrib": "/hub-http-contrib/static-1.2853",
  "interframe": "/interframe/static-3.4599",
  "tinymce-data": "/tinymce-data/static-1.39858",
  "tinymce-plugins": "/tinymce-plugins/static-1.56887",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5023",
  "magpie-lib": "/magpie-lib/static-1.5403",
  "magpie-types": "/magpie-types/static-1.4863",
  "simple-logging-lib": "/simple-logging-lib/static-1.2860",
  "content-assistance-lib": "/content-assistance-lib/static-1.7463",
  "dashboard-lib": "/dashboard-lib/static-1.80666",
  "ExportDialog": "/ExportDialog/static-6.10196",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17633",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17625",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8501",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8303",
  "feedback-loader": "/feedback-loader/static-1.28872",
  "onboarding-scopes": "/onboarding-scopes/static-1.6273",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4459",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.150",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4323",
  "nav-client-types": "/nav-client-types/static-1.2167",
  "purchase-motions-api": "/purchase-motions-api/static-1.5498",
  "trials-service-types": "/trials-service-types/static-1.3724",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1343",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.535",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.508",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17031",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12862",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5398",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7598",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10181",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31110",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10848",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6350",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.275",
  "customer-data-tracking": "/customer-data-tracking/static-1.6692",
  "commerce-permissions": "/commerce-permissions/static-1.568",
  "products-iframe-lib": "/products-iframe-lib/static-1.7344",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9879",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8592",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3965",
  "video-components-external": "/video-components-external/static-1.10595",
  "video-data-lib": "/video-data-lib/static-1.34254",
  "directed-graph": "/directed-graph/static-1.746",
  "event-emitter": "/event-emitter/static-1.757",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5334",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9580",
  "fsm": "/fsm/static-1.3541",
  "policy-lib": "/policy-lib/static-1.6596",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9643",
  "navigation-messaging": "/navigation-messaging/static-1.6626",
  "FileManagerLib": "/FileManagerLib/static-1.38557",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8905",
  "FileManagerCore": "/FileManagerCore/static-1.38416",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12050",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11025",
  "react-codemirror": "/react-codemirror/static-1.10436",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9698",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13926",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8506",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27969",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8378",
  "payment-link-components": "/payment-link-components/static-1.22967",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23929",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3005",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2809",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35052",
  "sales-views-client-types": "/sales-views-client-types/static-1.4097",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11490",
  "content-media-compositions": "/content-media-compositions/static-2.15497",
  "media-bridge-lib": "/media-bridge-lib/static-1.18580",
  "trellis-story-utils": "/trellis-story-utils/static-1.4331",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5626",
  "FileManagerImages": "/FileManagerImages/static-1.36068",
  "video-components": "/video-components/static-1.12598",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4342",
  "video-embed": "/video-embed/static-1.35088",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67726",
  "layout-data-lib": "/layout-data-lib/static-1.9350",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6393",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5734",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4896",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3478",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21322",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3654",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21377",
  "outpost": "/outpost/static-1.4014",
  "advanced-menus-core": "/advanced-menus-core/static-1.14828",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11801",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33451",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14827",
  "simple-menus-lib": "/simple-menus-lib/static-1.16344"
}
};
